import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './KycStyles.css';

const nextRoute = {
  selfie: '/id-front',
  'id-front': '/id-back',
  'id-back': '/submit',
};

const stateKey = {
  selfie: 'selfieImage',
  'id-front': 'idFrontImage',
  'id-back': 'idBackImage',
};

export default function ConfirmPhoto({ type }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { token } = useParams();
  const image = location.state?.image;

  if (!image) {
    navigate(`/${token}/selfie`);
    return null;
  }

  const handleRetake = () => {
    if (type === 'selfie') navigate(`/${token}/selfie`);
    if (type === 'id-front') navigate(`/${token}/id-front`);
    if (type === 'id-back') navigate(`/${token}/id-back`);
  };

  const handleConfirm = () => {
    navigate(`/${token}${nextRoute[type]}`, { state: { ...location.state, [stateKey[type]]: image } });
  };

  const progress = type === 'selfie' ? '33%' : type === 'id-front' ? '66%' : '100%';

  return (
    <div className="kyc-container">
      <div className="kyc-progress"><div className="kyc-progress-bar" style={{width: progress}} /></div>
      <h2 className="kyc-title">Confirm Photo</h2>
      <img src={image} alt="Captured" className="kyc-confirm-img" />
      <div className="kyc-btn-row">
        <button className="kyc-retake-btn" onClick={handleRetake}>Retake</button>
        <button className="kyc-confirm-btn" onClick={handleConfirm}>Confirm</button>
      </div>
    </div>
  );
} 